import { convertCurrencyToNumber } from '@util/convertCurrencyToNumber';
import isObjectEmpty from '@util/isObjectEmpty';
import { SelectOption } from '@util/types';

export const allCurrenciesOptions: SelectOption<string | null>[] = [
  { value: null, title: 'Original Currency' },
  { value: 'USD', title: 'US Dollars - USD' },
  { value: 'BSD', title: 'Bahamian Dollars - BSD' },
  { value: 'BZD', title: 'Belize Dollars - BZD' },
  { value: 'CAD', title: 'Canadian Dollars - CAD' },
  { value: 'CLP', title: 'Chilean Pesos - CLP' },
  { value: 'COP', title: 'Colombian Pesos - COP' },
  { value: 'CRC', title: 'Costa Rican Colón - CRC' },
  { value: 'EUR', title: 'Euros - EUR' },
  {
    value: 'KYD',
    title: 'Cayman Islands Dollars - KYD',
  },
  { value: 'MXN', title: 'Mexican Pesos - MXN' },
  { value: 'PEN', title: 'Peruvian Soles - PEN' },
  { value: 'UYU', title: 'Uruguayan Pesos - UYU' },
  { value: 'ARS', title: 'Argentine Pesos - ARS' },
];

export const currenciesWithSymbols = {
  USD: '$',
  BSD: 'BS$',
  BZD: 'BZ$',
  CAD: 'CAD$',
  CLP: 'CL$',
  COP: 'CO$',
  CRC: '₡',
  EUR: '€',
  KYD: 'KY$',
  MXN: 'MXN$',
  PEN: 'S/',
  UYU: 'UY$',
  ARS: 'AR$',
};

export const convertGivenCurrencyToSystemBaseCurrency = (
  amount,
  currencyData,
  complianceObj,
  propertyBaseCurrencyFromApi,
  userPreferredCurrency,
  locale = 'en-US',
) => {
  if (!userPreferredCurrency) {
    userPreferredCurrency = propertyBaseCurrencyFromApi || 'USD';
  }
  if (!isObjectEmpty(currencyData) && currencyData) {
    const usdConversions = { ...currencyData };
    usdConversions['USD'] = 1;
    const amountNumber = convertCurrencyToNumber(amount);
    let propertyBaseCurrency;
    if (propertyBaseCurrencyFromApi) {
      propertyBaseCurrency = propertyBaseCurrencyFromApi;
    } else if (!isObjectEmpty(complianceObj?.defaultCurrency)) {
      propertyBaseCurrency = complianceObj.defaultCurrency;
    } else {
      propertyBaseCurrency = 'USD';
    }
    const baseCurrencyAmt = usdConversions[propertyBaseCurrency];
    const systemBaseCurrencyRate = usdConversions[userPreferredCurrency];
    const amt = (amountNumber / baseCurrencyAmt) * systemBaseCurrencyRate;
    if (amt !== 0) {
      return convertNumberToCurrency(amt, userPreferredCurrency, locale);
    }
  }

  return amount;
};

export const convertNumberToCurrency = (number, currencyCode, locale = 'en-US') => {
  const hasFractionalPart = number % 1 !== 0;
  const numberFormat = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode || 'USD',
    maximumFractionDigits: hasFractionalPart ? 2 : 0,
    minimumFractionDigits: hasFractionalPart ? 2 : 0,
    currencyDisplay: 'code',
  });
  return numberFormat
    .format(number)
    .replace(new RegExp(`${currencyCode}\\s?`), currenciesWithSymbols[currencyCode]);
};

export const convertCurrency = (
  amount: number,
  conversionRates: any,
  fromCurrency: string,
  toCurrency: string,
  locale = 'en-US',
): number | null => {
  const fromRate = conversionRates[fromCurrency];
  const toRate = conversionRates[toCurrency];

  if (!fromRate || !toRate) {
    return null;
  }

  const baseAmount = amount / fromRate;
  const convertedAmount = baseAmount * toRate;
  return parseFloat(convertedAmount.toFixed(2));
};
